export default [{
    id: 'FEATURES',
    name: 'Fonctionnalités',
    description: 'Ces cookies vous permettent d\'accéder à des fonctionnalités présentes sur Yurplan et gérées par des sites internet extérieurs à Yurplan',
    cookies: [{
        id: 'FACEBOOK_CONNEXION',
        title: 'Facebook',
        group: 'FEATURES',
        description: 'Ce cookie tiers déposé par Facebook vous permet de vous connecter à Yurplan depuis votre compte Facebook. Cette connexion vous permet de ne pas créer de compte directement sur notre site, mais aussi d\'y importer vos événements facebook.',
        link: 'https://www.facebook.com/policies/cookies/',
        cookiesNames: [
            { fbmId: 'fbm_id' },
            { fbsrId: 'fbsr_id' },
            { spin: 'spin' },
            { act: 'act' },
            { fr: 'fr' },
            { locale: 'locale' },
            { presence: 'presence' },
            { pl: 'pl' },
            { xs: 'xs' },
            { wd: 'wd' },
            { c_user: 'c_user' },
            { sb: 'sb' },
            { datr: 'datr' },
        ],
    }, {
        id: 'TRUSTPILOT',
        title: 'TrustPilot',
        group: 'FEATURES',
        description: 'Ce cookie tiers déposé par TrustPilot nous permet d\'afficher notre score sur TrustPilot et vous permet d\'accéder aux commentaires des autres utilisateurs de la plateforme.',
        link: 'https://fr.legal.trustpilot.com/end-user-privacy-terms#cookies',
        cookiesNames: [
            { TP_uuid: 'TP.uuid' },
            { requestVerificationToken: '__RequestVerificationToken' },
            { asc: '__asc' },
            { auc: '__auc' },
            { ajs_anonymous_id: 'ajs_anonymous_id' },
            { ajs_group_id: 'ajs_group_id' },
            { ajs_user_id: 'ajs_user_id' },
            { amplitudeId: 'amplitude_id' },
            { amplitudeIdundefinedtrustpilotcom: 'amplitude_idundefinedtrustpilot.com' },
            { csrfCanary: 'csrf-canary' },
        ],
    }],
}, {
    id: 'ANALYTICS',
    name: 'Statistiques',
    description: 'Ces cookies nous aident par la collecte et la communication d\'informations à comprendre comment les visiteurs interagissent avec notre site.',
    cookies: [{
        id: 'GOOGLE_ANALYTICS',
        title: 'Google Analytics',
        group: 'ANALYTICS',
        description: 'Ce cookie tiers déposé par Google nous permet de mieux comprendre comment la Plateforme Yurplan est utilisée. Il permet de distinguer chaque utilisateur par l\'attribution d\'un identifiant unique.',
        link: 'https://policies.google.com/privacy?hl=fr&gl=fr',
        link2: 'https://policies.google.com/technologies/types?hl=fr',
        cookiesNames: [
            { ga: '_ga' },
            { gat: '_gat_id' },
            { gid: '_gid' },
        ],
    }, {
        id: 'HOTJAR',
        title: 'HotJar',
        group: 'ANALYTICS',
        description: 'Ce cookie tiers déposé par HotJar nous permet de visionner le parcours utilisateur sur le site. Il enregistre ainsi, entre autres, les pages visionnées, ainsi que les liens cliqués. La récolte de ces informations participe à l\'amélioration de notre plateforme.',
        link: 'https://www.hotjar.com/legal/policies/cookie-information',
        cookiesNames: [
            { hotj: '_hjIncludedInSample' },
        ],
    }, {
        id: 'GOOGLE_OPTIMIZE',
        title: 'Google Optimize',
        group: 'ANALYTICS',
        description: 'Ce service tiers proposé par Google est utilisé afin de personnaliser et déterminer l\'efficacité de nos contenus.',
        link: 'https://policies.google.com/privacy?hl=fr&gl=fr',
        cookiesNames: [],
    }],
}, {
    id: 'MARKETING',
    name: 'Marketing',
    description: 'Ces cookies sont utilisés pour suivre votre navigation sur des sites webs à des fins de ciblage publicitaire. Le but est d\'afficher des publicités relatives à nos produits sur les sites de tiers utilisant ces cookies et de mesurer leur efficacité.',
    cookies: [{
        id: 'FACEBOOK_PIXEL',
        title: 'Facebook Pixel',
        group: 'MARKETING',
        description: 'Ces cookies tiers déposés par Facebook nous permettent de vous proposer, sur le site de Facebook, des publicités relatives à nos produits et d\'effectuer le suivi statistique desdites publicités.',
        link: 'https://www.facebook.com/policies/cookies/',
        cookiesNames: [
            { spin: 'spin' },
            { act: 'act' },
            { fr: 'fr' },
            { locale: 'locale' },
            { presence: 'presence' },
            { pl: 'pl' },
            { xs: 'xs' },
            { wd: 'wd' },
            { c_user: 'c_user' },
            { sb: 'sb' },
            { datr: 'datr' },
            { fbp: '_fbp' },
        ],
    }, {
        id: 'LINKEDIN',
        title: 'LinkedIn',
        group: 'MARKETING',
        description: 'Ces cookies tiers déposés par LinkedIn nous permettent de vous proposer, sur le site de LinkedIn, des publicités relatives à nos produits, et d\'effectuer le suivi statistique desdites publicités',
        link: 'https://www.linkedin.com/legal/cookie-policy',
        cookiesNames: [
            { BizoId: 'BizoID' },
            { lang: 'lang' },
            { lipt: '_lipt' },
            { liap: 'liap' },
            { li_aotml: 'li_aotml' },
            { gat: 'gat' },
            { UserMatchHistory: 'UserMatchHistory' },
            { lidc: 'lidc' },
            { bcookie: 'bcookie' },
            { ga: '_ga' },
        ],
    }, {
        id: 'GOOGLE_ADS',
        title: 'Google Ads',
        group: 'MARKETING',
        description: 'Ce cookie tiers déposé par Google est utilisé par Google Ads afin de déterminer l\'efficacité de la publicité sur divers sites Web utilisant leurs services.',
        link: 'https://policies.google.com/privacy?hl=fr&gl=fr',
        link2: 'https://support.google.com/adsense/answer/7549925?hl=fr',
        link3: 'https://policies.google.com/technologies/types?hl=fr',
        cookiesNames: [
            { gcl_au: '_gcl_au' },
        ],
    }],
},
];
